import { Controller } from "@hotwired/stimulus";
import {clearInputs, populateSelectOptions} from "../utils/stimulus_form_helper";
export default class extends Controller {
  static targets = ["incomeTypeInput", "annualIncomeInput"];
  static values = {collectionSingle: Object, collectionFamily: Object};
  connect() {
    this.toggleIncomeType();
  }

  toggleIncomeType() {
    const selectInput = this.annualIncomeInputTarget;
    clearInputs(this, "annualIncomeInputTarget");
    if (this.incomeTypeInputTarget.value === "single") {
      populateSelectOptions(selectInput, this.collectionSingleValue);
    } else {
      populateSelectOptions(selectInput, this.collectionFamilyValue);
    }
  }

}
